import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabservinvadodara() {



  const cardData =
  {
    keyword: 'Corporate Cab Services in Vadodara',
    heading: 'Aaryan Travels: Corporate Cab Services in Vadodara',
    headingDescription: ' Aaryan Travels delivers reliable Corporate Cab Services in Vadodara, serving professionals, manufacturing units, and business travelers across the city’s industrial and commercial zones. Whether you need daily pick-and-drop for employees, executive transfers, airport pickups from Vadodara Airport, or intercity travel to Ahmedabad, Surat, or Mumbai, our fleet of sedans, SUVs, and luxury vehicles ensures a smooth and punctual experience. With trained chauffeurs, GPS-enabled cars, monthly rental contracts, and 24/7 support, we offer corporate cab solutions tailored to your company’s needs. From Makarpura GIDC to Alkapuri, Manjalpur to Gotri, Aaryan Travels is the trusted partner for dependable corporate transportation in Vadodara.',

    top: 'Top Places to Visit in Vadodara with Aaryan Travels',

"topPlaces": [
  {
    "title": "Lakshmi Vilas Palace",
    "description": "Lakshmi Vilas Palace is one of the grandest royal residences in India, built by Maharaja Sayajirao Gaekwad III in 1890. It is four times the size of Buckingham Palace and showcases Indo-Saracenic architecture with stained glass, mosaics, and ornate interiors. The palace complex also includes a museum and golf course. Visitors are stunned by its opulence and heritage. Lakshmi Vilas Palace is Vadodara’s crowning royal jewel."
  },
  {
    "title": "Sayaji Baug (Kamati Baug)",
    "description": "Sayaji Baug is a sprawling public garden spread over 100 acres featuring a zoo, planetarium, toy train, and museum. Families enjoy peaceful walks along tree-lined paths and landscaped lawns. The Baroda Museum and Picture Gallery inside houses rare paintings, artifacts, and Egyptian mummies. The floral beauty adds charm throughout the year. Sayaji Baug is Vadodara’s favorite leisure and heritage park."
  },
  {
    "title": "EME Temple (Dakshinamurthy Temple)",
    "description": "The EME Temple, managed by the Indian Army, is a unique modern structure dedicated to Lord Dakshinamurthy. Built using aluminum, it symbolizes unity of all religions with architectural elements from Hindu, Muslim, Buddhist, Jain, and Christian styles. The serene ambiance and well-maintained surroundings offer peace and purity. EME Temple is Vadodara’s symbol of unity in spirituality."
  },
  {
    "title": "Ajwa Water Park & Ajwa Lake",
    "description": "Ajwa Water Park is a popular entertainment destination featuring thrilling slides, wave pools, and family rides. Adjacent Ajwa Lake, built over a century ago, supplies water to the city and provides scenic sunset views. The lush surroundings offer a relaxing retreat from city life. Picnic groups and school outings often gather here. Ajwa is Vadodara’s joyful recreation and relaxation zone."
  },
  {
    "title": "Maharaja Fateh Singh Museum",
    "description": "Located within the Lakshmi Vilas Palace estate, this museum showcases royal collections including European paintings, marble statues, and bronze sculptures. Famous works by Raja Ravi Varma and European artists adorn the galleries. The museum offers insight into the taste and lifestyle of the Gaekwad dynasty. Maharaja Fateh Singh Museum is Vadodara’s artistic treasure house."
  },
  {
    "title": "Kirti Mandir",
    "description": "Kirti Mandir is a cenotaph built by Maharaja Sayajirao Gaekwad III in memory of his family members. The structure features intricate murals depicting events from Indian epics like Mahabharata and Ramayana. The peaceful surroundings and sacred aura attract devotees and history lovers alike. It stands as a symbol of royal devotion and architectural excellence. Kirti Mandir is Vadodara’s monument of remembrance."
  },
  {
    "title": "Sursagar Lake",
    "description": "Sursagar Lake is a centrally located waterbody surrounded by stone embankments, giving it a tranquil urban feel. A giant Shiva statue rises majestically from the lake’s center, illuminated beautifully at night. Boating is popular during cooler months. The calm waters reflect city lights, creating a mesmerizing view. Sursagar Lake is Vadodara’s peaceful evening retreat."
  },
  {
    "title": "Laxmi Vilas Palace Golf Club",
    "description": "Situated within the royal estate, this lush 10-hole golf course offers a premium sports experience amid historical surroundings. Towering trees and peacocks roaming freely enhance the regal ambiance. Golfers enjoy playing with palace views in the backdrop. It is often visited by professionals and luxury travelers. The Golf Club is Vadodara’s royal recreation getaway."
  },
  {
    "title": "Inorbit Mall Vadodara",
    "description": "Inorbit Mall is one of Vadodara’s premier shopping destinations featuring top fashion brands, modern food courts, and entertainment zones. Families and youngsters enjoy movies, arcade games, and weekend hangouts. The clean interiors and vibrant lighting enhance the overall experience. Inorbit Mall is Vadodara’s hub for modern lifestyle and leisure."
  },
  {
    "title": "Narmada Canal & Vishwamitri Riverfront",
    "description": "The Narmada Canal flowing through Vadodara creates scenic viewpoints ideal for evening strolls. Efforts are underway to develop the Vishwamitri Riverfront on the lines of Sabarmati Riverfront. Locals enjoy walking, cycling, and photography along these calm stretches. Monsoon adds to the greenery. The riverfronts are Vadodara’s emerging nature escapes."
  }
],


"services": [
  {
    "name": "Corporate Cab Services in Vadodara",
    "description": "Our Corporate Cab Services in Vadodara are designed to offer seamless and professional transportation solutions tailored for businesses of all sizes. We understand the importance of punctuality, comfort, and safety in corporate travel. Whether you need daily employee commutes, client pickups, or transportation for corporate events, our fleet of well-maintained vehicles and experienced drivers ensure a smooth and reliable journey every time. Our service aims to enhance your company's operational efficiency while providing a comfortable travel experience for your staff and guests."
  },
  {
    "name": "Vadodara Business Taxi",
    "description": "The Vadodara Business Taxi service caters specifically to the needs of business professionals requiring prompt, reliable, and comfortable transport. Our taxis are driven by courteous, trained chauffeurs who are well-acquainted with Vadodara’s commercial hubs and traffic patterns, ensuring timely arrivals for meetings, conferences, and site visits. With flexible booking options and competitive pricing, this service is ideal for executives and employees alike."
  },
  {
    "name": "Office Cab Hire Vadodara",
    "description": "Our Office Cab Hire service in Vadodara provides tailored transportation solutions to businesses looking for dependable staff commute options. We offer fixed-route and flexible scheduling to accommodate various shift timings, reducing the hassle of daily transport arrangements. Safety, punctuality, and convenience are our priorities, helping companies improve employee attendance and satisfaction."
  },
  {
    "name": "Chauffeur Driven Corporate Cabs Vadodara",
    "description": "Experience premium chauffeur-driven corporate cab services in Vadodara, where professionalism meets comfort. Our trained chauffeurs provide courteous and efficient service, ensuring your business travel is stress-free and productive. Ideal for executive travel, client meetings, and special corporate occasions, our fleet includes luxury sedans and SUVs equipped with modern amenities."
  },
  {
    "name": "Monthly Cab Rental Vadodara",
    "description": "Our Monthly Cab Rental service in Vadodara is designed for companies looking to streamline their employee transportation with cost-effective, long-term contracts. Enjoy consistent vehicle availability, transparent monthly billing, and customizable routes that adapt to your business’s evolving needs. This service offers peace of mind and operational efficiency for HR and transport managers."
  },
  {
    "name": "Employee Transport Services Vadodara",
    "description": "Dedicated to enhancing employee convenience and punctuality, our Employee Transport Services in Vadodara offer safe, reliable, and comfortable rides to and from the workplace. Equipped with GPS tracking and staffed by professional drivers, this service supports businesses in managing workforce mobility efficiently while boosting employee morale."
  },
  {
    "name": "Staff Cab Vadodara",
    "description": "Our Staff Cab service in Vadodara ensures smooth and timely transport for your employees, accommodating different shift timings and locations. We focus on safety, comfort, and reliability, making daily commutes hassle-free and helping businesses maintain consistent operational flow without transportation-related disruptions."
  },
  {
    "name": "Corporate Car Hire Vadodara",
    "description": "Offering a diverse fleet of corporate car hire options in Vadodara, we cater to executive travel, client transportation, and business events. Choose from premium sedans, SUVs, and luxury vehicles, all maintained to high standards and driven by professional chauffeurs to provide a prestigious and comfortable travel experience."
  },
  {
    "name": "Affordable Corporate Cab Vadodara",
    "description": "Our Affordable Corporate Cab service in Vadodara is perfect for startups and small to medium enterprises seeking quality corporate transport without stretching their budgets. We offer flexible pricing plans and packages that ensure cost-effective, reliable rides without compromising on safety or comfort."
  },
  {
    "name": "Executive Taxi Vadodara",
    "description": "The Executive Taxi service in Vadodara is designed for high-level corporate clients who demand professionalism, punctuality, and comfort. Featuring luxury vehicles and experienced drivers, this service supports your business travel needs with a touch of elegance and discretion."
  },
  {
    "name": "Company Cab Services Vadodara",
    "description": "Our Company Cab Services in Vadodara help businesses manage employee transportation efficiently with scheduled pickups, reliable vehicles, and attentive drivers. We support large and small teams alike, ensuring smooth daily commutes and reducing transportation-related challenges for companies."
  },
  {
    "name": "Premium Corporate Cabs Vadodara",
    "description": "Experience the best in corporate travel with our Premium Corporate Cabs in Vadodara. Featuring top-of-the-line vehicles, advanced safety features, and professional chauffeurs, this service is ideal for executives, client hospitality, and corporate events, ensuring a superior travel experience."
  },
  {
    "name": "Best Corporate Taxi Vadodara",
    "description": "Ranked among Vadodara’s best corporate taxi providers, our service is known for reliability, customer satisfaction, and professionalism. We prioritize timely pickups, clean and well-maintained vehicles, and drivers trained to meet the demands of corporate clients, making us the preferred choice for business travel."
  },
  {
    "name": "Online Booking Corporate Cabs Vadodara",
    "description": "Book your corporate cabs in Vadodara with ease through our online platform. Enjoy instant booking confirmations, secure payments, and flexible scheduling. Our digital system is designed to simplify corporate travel management, saving time and ensuring a hassle-free booking experience."
  },
  {
    "name": "Vadodara Corporate Sedan Rental",
    "description": "Our Vadodara Corporate Sedan Rental service offers sleek, comfortable sedans perfect for business meetings, airport transfers, and corporate travel. All vehicles are regularly serviced and driven by professional chauffeurs to guarantee a smooth and pleasant journey tailored to your business needs."
  }
],
"tableData": [
  ["Corporate Cab Services in Vadodara", "Vadodara Business Taxi"],
  ["Office Cab Hire Vadodara", "Chauffeur Driven Corporate Cabs Vadodara"],
  ["Monthly Cab Rental Vadodara", "Employee Transport Services Vadodara"],
  ["Staff Cab Vadodara", "Corporate Car Hire Vadodara"],
  ["Affordable Corporate Cab Vadodara", "Executive Taxi Vadodara"],
  ["Company Cab Services Vadodara", "Premium Corporate Cabs Vadodara"],
  ["Best Corporate Taxi Vadodara", "Online Booking Corporate Cabs Vadodara"],
  ["Vadodara Corporate Sedan Rental", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Corporate Cab Services in Vadodara",
    "WhyChoosedescription": "Aaryan Travels offers professional and punctual corporate cab services tailored for businesses in Vadodara."
  },
  {
    "WhyChooseheading": "Timely Pickup and Drop for Seamless Commutes",
    "WhyChoosedescription": "Ensure hassle-free daily commutes for your employees with our efficient and punctual cab services."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Business-Class Vehicles",
    "WhyChoosedescription": "Travel in sanitized, air-conditioned cabs designed to provide comfort and professionalism."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Vadodara’s Corporate Routes",
    "WhyChoosedescription": "Our drivers know the key business hubs and routes in Vadodara for smooth navigation."
  },
  {
    "WhyChooseheading": "Transparent Corporate Billing with No Hidden Charges",
    "WhyChoosedescription": "Get clear, GST-compliant invoices and all-inclusive pricing with no surprise costs."
  },
  {
    "WhyChooseheading": "24/7 Dedicated Support for Business Travel Needs",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with corporate bookings and coordination."
  },
  {
    "WhyChooseheading": "Flexible Contract Options: Daily, Weekly, or Monthly",
    "WhyChoosedescription": "Choose short-term or long-term cab hire contracts tailored to your organization’s needs."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles for Corporate Requirements",
    "WhyChoosedescription": "Select from sedans, SUVs, or tempo travellers based on your team size and travel preferences."
  }
]

























  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer corporate cab services in Vadodara?',
    answer: 'Yes, Aaryan Travels provides professional and reliable corporate cab services in Vadodara to cater to all business travel needs.',
  },
  {
    question: 'How can I book corporate cab services in Vadodara with Aaryan Travels?',
    answer: 'You can book corporate cabs through our website, mobile app, or by contacting our dedicated corporate support team.',
  },
  {
    question: 'What types of vehicles are available for corporate cab services in Vadodara?',
    answer: 'Aaryan Travels offers a fleet of sedans, SUVs, and premium cars suitable for executive and employee transportation in Vadodara.',
  },
  {
    question: 'Are Aaryan Travels’ corporate cab services suitable for daily employee commute in Vadodara?',
    answer: 'Yes, we offer customized corporate cab solutions for daily employee pickups and drops across Vadodara.',
  },
  {
    question: 'Are drivers experienced and trained for corporate travel requirements in Vadodara?',
    answer: 'Absolutely. Our drivers are professionally trained, courteous, and familiar with Vadodara and its corporate travel standards.',
  },
  {
    question: 'Can Aaryan Travels handle bulk or group cab bookings for corporate events in Vadodara?',
    answer: 'Yes, we specialize in managing group transportation and bulk cab bookings for corporate meetings and events in Vadodara.',
  },
  {
    question: 'Do you offer monthly billing or invoice options for corporate cab services in Vadodara?',
    answer: 'Yes, we provide flexible billing options including monthly invoicing for corporate clients in Vadodara.',
  },
  {
    question: 'Is your corporate cab service in Vadodara available 24x7?',
    answer: 'Yes, Aaryan Travels offers 24x7 corporate cab services to ensure seamless business travel in Vadodara.',
  },
  {
    question: 'What safety measures are in place for corporate cab services in Vadodara?',
    answer: 'All vehicles are sanitized regularly, and our drivers follow strict safety and hygiene protocols.',
  },
  {
    question: 'Can pickup and drop-off locations be customized for corporate cab bookings in Vadodara?',
    answer: 'Yes, we allow full customization of pickup and drop points based on your corporate travel requirements in Vadodara.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Anil Shah',
    feedback: 'Aaryan Travels’ corporate cab service in Vadodara is punctual, professional, and highly reliable for our company’s needs.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Mehta',
    feedback: 'Excellent corporate cab services by Aaryan Travels in Vadodara with great customer support and timely rides.',
    rating: 5,
  },
];
























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Vadodara",
  "image": "https://aaryantravels.com/assets/images/corporate-cab-vadodara.jpg", // replace with actual image URL
  "description": "Professional and affordable corporate cab services in Vadodara by Aaryan Travels. Perfect for office cab hire, employee transport, and business travel with options for sedans and executive cars.",
  "brand": {
    "@type": "Brand",
    "name": "Aaryan Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",  // example rating, update if needed
    "ratingCount": "1800", // example rating count, update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1900",  // example price, adjust as needed
    "availability": "https://schema.org/InStock",
    "url": "https://aaryantravels.com/corporate-cab-services-vadodara"
  }
};










  return (
    <div>

<Helmet>
  <title>Corporate Cab Services in Vadodara | Business Taxi Hire | Aaryan Travels</title>
  <meta
    name="description"
    content="Professional and affordable corporate cab services in Vadodara by Aaryan Travels. Perfect for office cab hire, employee transport, and business travel with options for sedans and executive cars."
  />
  <meta
    name="keywords"
    content="Corporate Cab Services in Vadodara, Vadodara Business Taxi, Office Cab Hire Vadodara, Chauffeur Driven Corporate Cabs Vadodara, Monthly Cab Rental Vadodara, Employee Transport Services Vadodara, Staff Cab Vadodara, Corporate Car Hire Vadodara, Affordable Corporate Cab Vadodara, Executive Taxi Vadodara, Company Cab Services Vadodara, Premium Corporate Cabs Vadodara, Best Corporate Taxi Vadodara, Online Booking Corporate Cabs Vadodara, Vadodara Corporate Sedan Rental"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/19.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabservinvadodara;